import { Base_Url } from "../../BaseUrl/BaseUrl";
import { getEventsLogin, clearEventsLogin } from '../../utils/eventsLogin';
import {
  deleteApiWithoutAuthorization,
  postApiWithoutAuthorization,
  putApiWithoutAuthorization,
  getApiWithAuthorization,
  getApiWithoutAuthorization
} from "../ApiMethods/ApiMethods";

const loginUrl = `${Base_Url}/login`;
const getRole = () => {
  const storedLogin = JSON.parse(localStorage.getItem("login"));
  return storedLogin?.role?.includes("student") ? "student" : "seeker";
};
export const registrationgetRole = () => {
  const type = localStorage.getItem("Type");
  return type === "student" ? "student" : "seeker";
};
export const VerifyLoginCredential = async (params) => {
  //
  const handle = getEventsLogin();
  const res = await postApiWithoutAuthorization(loginUrl, {
    ...params, ...(handle ? { events_sso_request: handle } : {}),
  });
  // const res = await Utils.LoginResponse;

  return res;
};
export const session_status = async () => {
  //
  const res = await getApiWithoutAuthorization(`${Base_Url}/session-status`);
  // const res = await Utils.LoginResponse;

  return res;
};
export const initial_registration = async (params) => {
  clearEventsLogin();
  //
  const res = await postApiWithoutAuthorization(
    `${Base_Url}/${getRole()}/initial_registration`,
    params
  );
  // const res = await Utils.LoginResponse;

  return res;
};

export const final_registration = async (params) => {
  //
  const res = await postApiWithoutAuthorization(
    `${Base_Url}/${registrationgetRole()}/final_registration`,
    params
  );
  // const res = await Utils.LoginResponse;

  return res;
};

export const forgot_pass = async (params) => {
  //
  const res = await postApiWithoutAuthorization(
    `${Base_Url}/forgot_pass`,
    params
  );
  // const res = await Utils.LoginResponse;

  return res;
};
export const reset_password = async (params) => {
  //
  const res = await putApiWithoutAuthorization(
    `${Base_Url}/change-password`,
    params
  );
  // const res = await Utils.LoginResponse;

  return res;
};
export const verifyToken = async (token) => {
  try {
    const res = await getApiWithoutAuthorization(`${Base_Url}/forgotpasswordtoken/${token}`);
    return res;
  } catch (error) {
    throw error; // Let the calling component handle the error
  }
};

export const verifyEmailToken = async (token) => {
  try {

    const res = await getApiWithoutAuthorization(`${Base_Url}/seeker/verify/${token}`);
    return res;
  } catch (error) {
    throw error; // Let the calling component handle the error
  }
};

export const get_logout_user = async (filter) => {
  //
  const res = await deleteApiWithoutAuthorization(`${Base_Url}/logout`);
  // const res = await Utils.LoginResponse;

  return res;
};
